import { render, staticRenderFns } from "./base-form.vue?vue&type=template&id=2ee78bbe&"
import script from "./base-form.vue?vue&type=script&lang=js&"
export * from "./base-form.vue?vue&type=script&lang=js&"
import style0 from "./base-form.vue?vue&type=style&index=0&id=2ee78bbe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports